import React from 'react';
import { useDispatch } from 'react-redux';
import Heading from '../../components/header';
import useApiLoadingOverlay from '../../hooks/useApiLoadingOverlay';
import SiteAboutUsContainer from '../../container/siteAboutUsContainer';
import { actionNotifier } from '../../components/ui/toast';
import {
    useGetAboutUsListQuery,
    useUpdateAboutUsListMutation,
    useUploadAboutUsFileMutation,
} from './aboutUsApiSlice';

const getPayload = (list) => (
    list.map((item) => ({
        name: item.name.trim(),
        designation: item.designation.trim(),
        image: item.image,
        serialNumber: Number(item.serialNumber) || 0,
    }))
);

const SiteAboutUsPage = () => {
    const dispatch = useDispatch();
    const [search, setSearch] = React.useState('');
    const [aboutUsList, setAboutUsList] = React.useState([]);

    const { data: fetchedList, isLoading: isFetching } = useGetAboutUsListQuery();
    const [updateAboutUsList, { isLoading: isUpdating }] = useUpdateAboutUsListMutation();
    const [uploadFile, { isLoading: isUploading }] = useUploadAboutUsFileMutation();

    useApiLoadingOverlay([isUpdating, isUploading, isFetching], dispatch);

    React.useEffect(() => {
        if (fetchedList && Array.isArray(fetchedList)) {
            const mappedList = fetchedList.map((item, index) => ({
                id: item.id || Date.now() + index,
                name: item.name || item.title || '',
                designation: item.designation || '',
                image: item.image || item.imageUrl || item.link || '',
                serialNumber: item.serialNumber !== undefined ? Number(item.serialNumber) : (index + 1),
                createdAt: item.createdAt || new Date().toISOString(),
            }));
            setAboutUsList(mappedList);
        }
    }, [fetchedList]);

    const onSearch = (event) => {
        setSearch(event.target.value);
    };

    const handleUploadFile = async (file) => {
        const formData = new FormData();
        formData.append('file', file);
        const response = await uploadFile(formData).unwrap();
        return response?.link || response?.data?.link || null;
    };

    const handleSaveAboutUs = async (formData) => {
        let nextList = [];

        if (formData.id) {
            nextList = aboutUsList.map((item) => (
                item.id === formData.id
                    ? { ...item, name: formData.name.trim(), designation: formData.designation.trim(), image: formData.image, serialNumber: formData.serialNumber }
                    : item
            ));

            nextList.sort((a, b) => (Number(a.serialNumber) || 0) - (Number(b.serialNumber) || 0));

            await updateAboutUsList(getPayload(nextList)).unwrap();
            setAboutUsList(nextList);
            actionNotifier.success('About Us updated successfully.');
            return;
        }

        nextList = [
            {
                id: Date.now(),
                name: formData.name.trim(),
                designation: formData.designation.trim(),
                image: formData.image,
                serialNumber: formData.serialNumber,
                createdAt: new Date().toISOString(),
            },
            ...aboutUsList,
        ];

        nextList.sort((a, b) => (Number(a.serialNumber) || 0) - (Number(b.serialNumber) || 0));

        await updateAboutUsList(getPayload(nextList)).unwrap();
        setAboutUsList(nextList);
        actionNotifier.success('About Us saved successfully.');
    };

    const handleDeleteAboutUs = async (id) => {
        const nextList = aboutUsList.filter((item) => item.id !== id);
        await updateAboutUsList(getPayload(nextList)).unwrap();
        setAboutUsList(nextList);
        actionNotifier.success('About Us removed successfully.');
    };

    const handleEditAboutUs = (item) => {
        return item;
    };

    return (
        <>
            <Heading
                text="About Us"
                path="#"
                onSearch={onSearch}
                search={search}
                isFilterShow={false}
                isGraphShow={false}
            />
            <SiteAboutUsContainer
                aboutUsList={aboutUsList}
                onSaveAboutUs={handleSaveAboutUs}
                onDeleteAboutUs={handleDeleteAboutUs}
                onEditAboutUs={handleEditAboutUs}
                onUploadFile={handleUploadFile}
                search={search}
                isLoading={isUpdating || isUploading}
            />
        </>
    );
};

export default SiteAboutUsPage;
